import Grid from "@mui/material/Grid";

import Tooth from "../../../assets/images/details/tooth.svg";
import { IconsList, List, Text } from "../styles/ProductStyles";
import type { ProductProcedures } from "../types/productTypes";

type ProductProcedureListProps = {
  procedures: ProductProcedures;
};

export const ProductProcedureList = ({
  procedures,
}: ProductProcedureListProps) => {
  return (
    <Grid container marginTop={5} marginBottom={5}>
      {procedures.descriptions?.map((description) => (
        <Grid size={{ xs: 12, md: 4 }} key={`detalhes_${description}`}>
          <List>
            <IconsList src={Tooth} alt="Ícone de dente" />
            <Text>{description}</Text>
          </List>
        </Grid>
      ))}
    </Grid>
  );
};